import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../utils/store/AllReducers";

const ProtectedRoute = () => {
    const { userLogin } = useSelector((state: RootState) => state.auth);
    
    return userLogin ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
